import type { RobotLoginSession, RobotOperation } from "../types";
import { apiClient } from "./apiClient";

export const robotApi = {
  getOperation: (operationId: string) => apiClient<RobotOperation>(`/robot-operations/${operationId}`),
  startLogin: (requestId: string, username: string, password: string) =>
    apiClient<RobotLoginSession>(`/availability-requests/${requestId}/robot-login`, {
      method: "POST",
      body: JSON.stringify({ username, password })
    }),
  startStatusCheckLogin: (jobId: string, username: string, password: string) =>
    apiClient<RobotLoginSession>(`/jobs/${jobId}/robot-status-check-login`, {
      method: "POST",
      body: JSON.stringify({ username, password })
    }),
  runOfferRobot: (requestId: string) =>
    apiClient<RobotLoginSession>(`/availability-requests/${requestId}/robot-run`, {
      method: "POST"
    }),
  runStatusCheckRobot: (jobId: string) =>
    apiClient<RobotLoginSession>(`/jobs/${jobId}/robot-status-check`, {
      method: "POST"
    }),
  submitMfa: (sessionId: string, code: string) =>
    apiClient<RobotLoginSession>(`/robot-sessions/${sessionId}/mfa`, {
      method: "POST",
      body: JSON.stringify({ code })
    }),
  getSession: (sessionId: string) =>
    apiClient<RobotLoginSession>(`/robot-sessions/${sessionId}`),
  closeSession: (sessionId: string) =>
    apiClient<void>(`/robot-sessions/${sessionId}`, { method: "DELETE" })
};
